import moment from 'moment';

export function formatDateAsShortDate(date) {
    return moment(date).format('Do MMMM YYYY');
}

export function formatDateAsDayMonthTime(date) {
    return moment(date).format('dddd Do MMMM, h:mm A');
}